import { financialSupervisor } from './finalcialSupervisor'
import { financialExecutive } from './financialExecutive'

const external = {
  financial_supervisor: financialSupervisor,
  financier_executive: financialExecutive,
}

export default external
